export const homePage = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            delay: .25,
            duration: .25,
            staggerChildren: .75,
            when: "beforeChildren",
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5,
        }
    }
}

export const homeSpanRight = {
    initial:{
        x: "100%",
        opacity: 0
    },
    animate:{
        x: 0,
        opacity: 1,
        transition:{
            duration: .75,
            ease: "easeOut"
        }
    }
}

export const homeSpanLeft = {
    initial:{
        x: "-100%",
        opacity: 0
    },
    animate:{
        x: 0,
        opacity: 1,
        transition:{
            duration: .75,
            ease: "easeOut"
        }
    }
}

export const homeSpanBot = {
    initial:{
        y: "100%",
        opacity: 0
    },
    animate:{
        y: 0,
        opacity: 1,
        transition:{
            duration: .75,
            ease: "easeOut"
        }
    }
}

export const homeSpanTop = {
    initial:{
        y: "-100%",
        opacity: 0
    },
    animate:{
        y: 0,
        opacity: 1,
        transition:{
            duration: .75,
            ease: "easeOut"
        }
    }
}

export const spanAnim = {
    initial: {
        y: "100%",
        opacity: 0
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            staggerChildren: 0.01,
            ease: [.74,2,.63,1],
            duration: .5
        }
    }
}

export const socialVar = {
    initial:{
        opacity: 0
    },
    animate:{
        opacity: 1,
        transition:{
            duration: .75,
            ease: "easeOut",
            staggerChildren: .65,
            staggerDirection: -1
        }
    },
    exit:{
        opacity: 0
    }
}

export const socialAnim = {
    initial:{
        opacity: 0
    },
    animate:{
        opacity: 1,
        transition:{
            ease: "easeOut",
            staggerChildren: .5,
            staggerDirection: -1
        }
    }
}

export const socialBot = {
    initial:{
        y: "100%",
        opacity: 0,
    },
    animate:{
        y: 0,
        opacity: 1,
        scale: [.5, .8, 1.5, 1],
        transition:{
            duration: .25,
            ease: "easeOut",
        }
    },
    exit:{
        y: 0,
        opacity: 0,
    }
}

export const socialLine = {
    initial:{
        height: 0,
    },
    animate:{
        height: "35vh",
        transition:{
            duration: .75,
            ease: "easeOut"
        }
    },
    exit:{
        height: 0
    }
}